// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tk-0";
export var checkoutRateBadgeLink = "_tk-1";